import React from 'react';
import { Mail, MessageSquare, Send } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
export function Contact() {
  return <div className="min-h-screen bg-[#0a0a0a]" data-id="element-291">
      {/* Hero Section */}
      <div className="relative bg-[#050505] py-20 border-b border-[#222]" data-id="element-292">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/2 h-[1px] bg-gradient-to-r from-transparent via-[#D22B2B] to-transparent opacity-50" data-id="element-293"></div>

        <div className="container mx-auto px-4" data-id="element-294">
          <div className="max-w-4xl mx-auto text-center" data-id="element-295">
            <div className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 border border-[#333] bg-black/50 backdrop-blur-md rounded-full" data-id="element-296">
              <MessageSquare className="w-3 h-3 text-[#D22B2B]" data-id="element-297" />
              <span className="font-serif uppercase tracking-[0.3em] text-[10px] text-gray-400" data-id="element-298">
                Контакты
              </span>
            </div>

            <h1 className="font-noir text-5xl md:text-7xl font-medium text-white mb-6 tracking-tight" data-id="element-299">
              Свяжитесь <br data-id="element-300" />
              <span className="text-[#D22B2B]" data-id="element-301">с нами</span>
            </h1>

            <p className="text-lg text-gray-400 font-serif font-light leading-relaxed" data-id="element-302">
              Мы всегда рады вашим вопросам, предложениям и отзывам
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16" data-id="element-303">
        <div className="max-w-4xl mx-auto" data-id="element-304">
          <div className="grid md:grid-cols-2 gap-12" data-id="element-305">
            {/* Contact Info */}
            <div className="space-y-8" data-id="element-306">
              <div data-id="element-307">
                <h2 className="font-noir text-3xl text-white mb-8 tracking-wide" data-id="element-308">
                  Контактная информация
                </h2>

                <div className="space-y-6" data-id="element-309">
                  <div className="bg-[#141414] p-6 border border-[#333] hover:border-[#D22B2B]/50 transition-colors duration-300" data-id="element-310">
                    <div className="flex items-start gap-4" data-id="element-311">
                      <div className="p-2 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full" data-id="element-312">
                        <Mail className="w-5 h-5" data-id="element-313" />
                      </div>
                      <div data-id="element-314">
                        <h3 className="font-serif text-sm font-bold uppercase tracking-[0.2em] text-[#D22B2B] mb-2" data-id="element-315">
                          Электронная почта
                        </h3>
                        <a href="mailto:info@kinosovety.ru" className="text-gray-300 hover:text-white transition-colors font-serif" data-id="element-316">
                          info@kinosovety.ru
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="bg-[#141414] p-6 border border-[#333] hover:border-[#D22B2B]/50 transition-colors duration-300" data-id="element-317">
                    <div className="flex items-start gap-4" data-id="element-318">
                      <div className="p-2 bg-[#D22B2B]/10 text-[#D22B2B] border border-[#D22B2B]/30 rounded-full" data-id="element-319">
                        <MessageSquare className="w-5 h-5" data-id="element-320" />
                      </div>
                      <div data-id="element-321">
                        <h3 className="font-serif text-sm font-bold uppercase tracking-[0.2em] text-[#D22B2B] mb-2" data-id="element-322">
                          Обратная связь
                        </h3>
                        <a href="mailto:feedback@kinosovety.ru" className="text-gray-300 hover:text-white transition-colors font-serif" data-id="element-323">
                          feedback@kinosovety.ru
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-[#141414] p-8 border-l-2 border-[#D22B2B]" data-id="element-324">
                <h3 className="font-noir text-xl text-white mb-4" data-id="element-325">
                  Время ответа
                </h3>
                <p className="text-gray-400 font-serif text-sm leading-relaxed" data-id="element-326">
                  Мы стараемся отвечать на все письма в течение 24-48 часов в
                  рабочие дни. Спасибо за ваше терпение.
                </p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-[#141414] p-8 border border-[#333]" data-id="element-327">
              <h2 className="font-noir text-2xl text-white mb-6 tracking-wide" data-id="element-328">
                Напишите нам
              </h2>

              <form className="space-y-6" data-id="element-329">
                <Input label="Ваше имя" type="text" placeholder="Иван Иванов" className="bg-[#0a0a0a]" data-id="element-330" />

                <Input label="Email" type="email" placeholder="ivan@example.com" className="bg-[#0a0a0a]" data-id="element-331" />

                <div className="w-full" data-id="element-332">
                  <label className="block text-xs font-serif uppercase tracking-widest text-gray-300 mb-2 ml-1" data-id="element-333">
                    Сообщение
                  </label>
                  <textarea rows={6} placeholder="Ваше сообщение..." className="w-full px-4 py-3 bg-[#0a0a0a] text-gray-200 border border-[#333] placeholder:text-gray-700 focus:outline-none focus:border-[#D22B2B] focus:ring-1 focus:ring-[#D22B2B]/50 transition-all duration-300 shadow-inner resize-none" data-id="element-334" />
                </div>

                <Button variant="primary" className="w-full" type="submit" data-id="element-335">
                  <Send className="w-4 h-4 mr-2" data-id="element-336" />
                  Отправить сообщение
                </Button>
              </form>

              <p className="mt-6 text-xs text-gray-500 font-serif text-center" data-id="element-337">
                Отправляя форму, вы соглашаетесь с обработкой персональных
                данных
              </p>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-16 border-t border-[#222] pt-12" data-id="element-338">
            <h2 className="font-noir text-3xl text-white mb-8 tracking-wide text-center" data-id="element-339">
              Часто задаваемые вопросы
            </h2>

            <div className="space-y-4 max-w-3xl mx-auto" data-id="element-340">
              <details className="bg-[#141414] border border-[#333] group" data-id="element-341">
                <summary className="p-6 cursor-pointer font-serif text-gray-300 hover:text-white transition-colors list-none flex items-center justify-between" data-id="element-342">
                  <span data-id="element-343">Как добавить фильм в избранное?</span>
                  <span className="text-[#D22B2B] group-open:rotate-180 transition-transform" data-id="element-344">
                    ▼
                  </span>
                </summary>
                <div className="px-6 pb-6 text-gray-400 font-serif text-sm leading-relaxed border-t border-[#222] pt-4" data-id="element-345">
                  Войдите в свой аккаунт, откройте страницу фильма и нажмите
                  кнопку "Любимое" под постером.
                </div>
              </details>

              <details className="bg-[#141414] border border-[#333] group" data-id="element-346">
                <summary className="p-6 cursor-pointer font-serif text-gray-300 hover:text-white transition-colors list-none flex items-center justify-between" data-id="element-347">
                  <span data-id="element-348">Можно ли скачать фильмы?</span>
                  <span className="text-[#D22B2B] group-open:rotate-180 transition-transform" data-id="element-349">
                    ▼
                  </span>
                </summary>
                <div className="px-6 pb-6 text-gray-400 font-serif text-sm leading-relaxed border-t border-[#222] pt-4" data-id="element-350">
                  Сервис предназначен для онлайн-просмотра. Скачивание доступно
                  только для фильмов, находящихся в общественном достоянии.
                </div>
              </details>

              <details className="bg-[#141414] border border-[#333] group" data-id="element-351">
                <summary className="p-6 cursor-pointer font-serif text-gray-300 hover:text-white transition-colors list-none flex items-center justify-between" data-id="element-352">
                  <span data-id="element-353">Как предложить фильм для добавления?</span>
                  <span className="text-[#D22B2B] group-open:rotate-180 transition-transform" data-id="element-354">
                    ▼
                  </span>
                </summary>
                <div className="px-6 pb-6 text-gray-400 font-serif text-sm leading-relaxed border-t border-[#222] pt-4" data-id="element-355">
                  Напишите нам на feedback@kinosovety.ru с названием фильма,
                  годом выпуска и киностудией. Мы рассмотрим ваше предложение.
                </div>
              </details>
            </div>
          </div>
        </div>
      </div>
    </div>;
}